export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betrag"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ergebnis"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaktion"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status aktualisieren"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nützliche Links"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In Bearbeitung"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreich"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehlgeschlagen"])}
}